import { IFormValidation } from '@aston/foundation';

export class ICreateRegistrationUserFederationValidator implements IFormValidation {
	ruleset = 'createRegistrationUserFederationCommandValidator';
	fields = {
		UserName: 'UserName',
		FederationId: 'federationId'
	};
}

export const CreateRegistrationUserFederationValidator = new ICreateRegistrationUserFederationValidator();
